import type { Environment } from '@sg/common';
import { detectExternalProvider, oidcUriNormalizer } from '../utils';
import type { SgApplicationConfiguration } from './types';

const PATHNAME_DETECT_REGEXP = new RegExp(`^(?:#/|#|/)(sg-lead)(?:/|\\?|().*)?$`);
const HOSTNAME_DETECT_REGEXP = new RegExp(`^lead(?:-.*)?\\.sharegain\\.com$`);
const CITI_SUBDOMAIN = 'citi-lead';
const CITI_SUBDOMAIN_TEST = 'citi-lead-test';
const ALLOWED_HOSTNAMES = [`${CITI_SUBDOMAIN}.sharegain.com`, `${CITI_SUBDOMAIN_TEST}.sharegain.com`];

declare module '@sg/pre-app-init/src/lib/application' {
  export interface SgCustomAppBranding {
    'sg-lead': {
      hideTopBar: boolean;
    };
  }
}

export const sgLead: SgApplicationConfiguration<'sg-lead'> = {
  name: 'sg-lead',
  authType: 'oidc',
  branding: {
    css: 'sg-lead-theme',
    favIcon: 'assets/images/favicon/favicon.ico',
    sidenavBackgroundImg: 'assets/sg-lead/images/menu-bg.svg',
    showSideBarExpender: false,
    sideMenuInitialState: 'opened',
    hideActionsMenu: true,
  },
  brandingMap: {
    [CITI_SUBDOMAIN]: {
      redirectToBranding: 'citi',
    },
    [CITI_SUBDOMAIN_TEST]: {
      redirectToBranding: 'citi',
    },
    citi: {
      logo: 'assets/images/sharegain-logo-citi.svg',
      logoContrast: 'assets/images/sharegain-logo-citi-white.svg',
      preLogo: 'assets/images/sharegain-logo-citi.svg',
      favIcon: 'assets/images/favicon/citi-favicon.ico',
      sidenavBackgroundImg: 'assets/sg-lead/images/menu-bg.svg',
      hideActionsMenu: true,
      showSideBarExpender: false,
      sideMenuInitialState: 'opened',
    },
    standAlone: {
      name: 'standAlone',
      hideSideNav: true,
      hideTopBar: true,
      custom: {
        hideTopBar: true,
      },
    },
  },
  matcher: (location: Location) => {
    return (
      PATHNAME_DETECT_REGEXP.test(location.pathname) ||
      PATHNAME_DETECT_REGEXP.test(location.hash) ||
      HOSTNAME_DETECT_REGEXP.test(location.hostname) ||
      ALLOWED_HOSTNAMES.includes(location.hostname)
    );
  },
  beforeLogin: (env: Environment) => {
    const { oidc } = env;
    oidc.acr_values = 'tenant:Lender';

    const externalProvider = detectExternalProvider();
    if (externalProvider) {
      oidc.acr_values = 'tenant:Lender idp:' + externalProvider;
    }

    const queryParams = new URLSearchParams(location.search);
    const brand = queryParams.get('brand');
    if (brand === 'standAlone') {
      oidc.prompt = 'none';
    }

    // by default, OIDC redirects are set under the assumption of a path app (hostname.com/SG-APPNAME)
    // when it's not the case we need to set the redirects properly.
    if (!PATHNAME_DETECT_REGEXP.test(location.pathname) && !PATHNAME_DETECT_REGEXP.test(location.hash)) {
      oidcUriNormalizer(oidc);
    }
  },
};
